(function () {
  'use strict';

  var STORAGE_COLUMNS = 'collection-grid-columns';
  var STORAGE_COLUMNS_MOBILE = 'collection-grid-columns-mobile';
  var VALID_COLUMNS = ['3', '4', '5'];
  var VALID_COLUMNS_MOBILE = ['1', '2'];

  function init() {
    var container = document.querySelector('collection-component');
    if (!container || container.dataset.viewControlsBound === 'true') return;
    container.dataset.viewControlsBound = 'true';

    var columnButtons = container.querySelectorAll('[data-grid-columns]');
    var savedColumns = localStorage.getItem(STORAGE_COLUMNS);

    if (savedColumns && VALID_COLUMNS.indexOf(savedColumns) !== -1 && columnButtons.length) {
      container.style.setProperty('--COLUMNS', savedColumns);
      columnButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-grid-columns') === savedColumns);
      });
    }

    columnButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-grid-columns');
        if (VALID_COLUMNS.indexOf(cols) === -1) return;
        container.style.setProperty('--COLUMNS', cols);
        localStorage.setItem(STORAGE_COLUMNS, cols);

        columnButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    var mobileButtons = container.querySelectorAll('[data-grid-columns-mobile]');
    var savedMobile = localStorage.getItem(STORAGE_COLUMNS_MOBILE);

    if (savedMobile && VALID_COLUMNS_MOBILE.indexOf(savedMobile) !== -1 && mobileButtons.length) {
      container.style.setProperty('--COLUMNS-MOBILE', savedMobile);
      container.style.setProperty('--COLUMNS-SMALL', savedMobile);
      mobileButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-grid-columns-mobile') === savedMobile);
      });
    }

    mobileButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-grid-columns-mobile');
        if (VALID_COLUMNS_MOBILE.indexOf(cols) === -1) return;
        container.style.setProperty('--COLUMNS-MOBILE', cols);
        container.style.setProperty('--COLUMNS-SMALL', cols);
        localStorage.setItem(STORAGE_COLUMNS_MOBILE, cols);

        mobileButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    var mobileQuery = window.matchMedia('(max-width: 749px)');

    // Each card stores its own sock/model slide index because gallery order varies.
    function scrollSlidersToView(showSock) {
      var sliders = container.querySelectorAll('[data-hover-slider]');
      sliders.forEach(function (slider) {
        var attr = showSock
          ? slider.getAttribute('data-sock-index')
          : slider.getAttribute('data-model-index');
        var idx = parseInt(attr, 10);
        if (isNaN(idx)) idx = showSock ? 1 : 0;

        function applyScroll() {
          var slideWidth = slider.clientWidth;
          if (slideWidth <= 0) return false;
          var left = slideWidth * idx;
          // Prefer scrollLeft — more reliable than scrollTo({ behavior: 'instant' })
          // which is unsupported / throws in some mobile Safari versions.
          slider.scrollLeft = left;
          return true;
        }

        if (!applyScroll()) {
          requestAnimationFrame(function () {
            if (!applyScroll()) {
              setTimeout(applyScroll, 50);
            }
          });
        }
      });
    }

    function applyImageView(showSock) {
      container.classList.toggle('collection--flat-view', showSock);
      if (mobileQuery.matches) {
        scrollSlidersToView(showSock);
      }
    }

    function getViewToggle() {
      return container.querySelector('[data-view-toggle]');
    }

    var viewToggle = getViewToggle();
    if (viewToggle) {
      // Always start on MODEL (checked). Not persisted — keeps A/B baseline stable.
      viewToggle.checked = true;
      applyImageView(false);
    }

    // Event delegation so the switch keeps working after collection AJAX re-renders.
    container.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.matches || !target.matches('[data-view-toggle]')) return;
      applyImageView(!target.checked);
    });

    // SOCK / MODEL text labels sit outside the <label>; make them toggle too.
    container.addEventListener('click', function (e) {
      var label = e.target.closest('.view-toggle__label');
      if (!label || !container.contains(label)) return;
      var toggleWrap = label.closest('.view-image-toggle');
      if (!toggleWrap) return;
      var input = toggleWrap.querySelector('[data-view-toggle]');
      if (!input) return;

      e.preventDefault();
      var wantModel = label.textContent.replace(/\s+/g, '').toUpperCase() === 'MODEL';
      input.checked = wantModel;
      applyImageView(!input.checked);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind if Shopify section rendering replaces the collection node.
  document.addEventListener('shopify:section:load', init);
})();
